//GeneratorFlag:[NoChange]
import { Server } from '@/core/server'
export default class BranchTypeService
{
	constructor(){}

	server(config)
	{
		return new Server(config)
	}

	//GeneratorFlag:[BranchType.Detail]
	async detail(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/hub/branch-type/detail', {'params':params});
	};

	//GeneratorFlag:[BranchType.List]
	async list(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/hub/branch-type/list', {'params':params});
	};

//GeneratorFlag:[NewAction]
}